import React from "react";
import { authRoles } from "../../auth/authRoles";

const AddNewSubDocumentTypeRoutes = [

  {
    path: "/add_new_sub_document_type",
    component: React.lazy(() => import("./AllAddNewSubDocumentType")),
    auth: authRoles.datasetup
  },
  
];

export default AddNewSubDocumentTypeRoutes;
